import * as React from 'react';
import { TopToolbar, useListContext, List, TextField, DateField, ReferenceField, EditButton, Pagination } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar, Grid } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Button, Toolbar } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getTsBuildInfoEmitOutputFilePath } from 'typescript';
import parse, { attributesToProps } from 'html-react-parser';
import Box from '@material-ui/core/Box';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Moment from 'moment';
import SportsIcon from '@material-ui/icons/Sports';
import DateRangeIcon from '@material-ui/icons/DateRange';

import CallIcon from '@material-ui/icons/Call';
import './ContactUs.css';

//import PostPagination from './PostPagination';

const cardStyle = {
    width: 300,
    minHeight: 300,
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            width: '500',
            //margin:'0 auto',

        },
        paper: {
            padding: theme.spacing(1),
            margin: 10,
            // maxWidth: 1000,
            // width: '100%',
            backgroundColor: '#F7F7F7',
            // display: 'flex',
            // justifyContent:'center'
        },
        image: {
            //width: 300,
            //height: 300,
            // margin: '0 auto',
        },
        img: {
            margin: 'auto',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },

        playlistContainer: {
            backgroundColor: "lightgrey",
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "0",
            left: "0",
            overflow: "auto",
            [theme.breakpoints.down("sm")]: {
                position: "relative"
            }
        }
    }),
);

const options = {
    replace: domNode =>
    {
        if (domNode.attribs && domNode.name === 'main')
        {
            const props = attributesToProps(domNode.attribs);
            return <div {...props} />;
        }
    }
};

const ListActions = (props) => (
    <TopToolbar>

    </TopToolbar>
);


const ContactUsGrid = () =>
{
    const classes = useStyles();
    const { ids, data, basePath } = useListContext();

    return (

        <div className={classes.root}>


            {ids.map(id => (

                // data.map(id =>
                <Paper className={classes.paper} key={data[id].id}>
                    <Grid container spacing={1}>
                        
                        <Grid item xs={6} container spacing={12}>

                            <Grid item xs={1}>
                                <Typography gutterBottom variant="h5" align="center">
                                    <Box mt={0.8} >
                                        <CallIcon />
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={11}>
                                <Typography gutterBottom variant="h5" align="left">

                                    Телефон
                                </Typography>
                                <Typography gutterBottom align="left">
                                   +371 29548140
                                </Typography>
                            </Grid>

                            <Grid item xs={1} >
                                <Typography gutterBottom variant="h5" align="center">
                                    <Box mt={0.8} >
                                        <LocationOnIcon />
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={11} >
                                <Typography gutterBottom variant="h5" align="left">
                                Адрес
                                </Typography>
                                </Grid>

                                <Grid item xs={1} >
                                    </Grid>
                                <Grid item xs={11}>
                                <Typography gutterBottom align="left">
                                    Rīga, Senču iela 4
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                              

                                    <div class="iframe-maps">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2174.8461103356526!2d24.141613016135807!3d56.96856850503681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eece4ccfe035a7%3A0x87917ab86754e56c!2zU2VuxI11IGllbGEgNCwgVmlkemVtZXMgcHJpZWvFoXBpbHPEk3RhLCBSxKtnYSwgTFYtMTAxMiwgTGF0dmlh!5e0!3m2!1sen!2sid!4v1629224683002!5m2!1sen!2sid"

                                            frameBorder="0"
                                            style={{ border: 0, maxWidth: '800px', maxHeight: '800px', minWidth: '100px', minHeight: '300px', position: 'relative' }}
                                            allowFullScreen=""
                                            aria-hidden="false"
                                            tabIndex="0"
                                        />
                                    </div>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}  >
                            <Grid item xs={12} >

                                <Typography gutterBottom variant="h5" align="center">
                                {/* <DateRangeIcon/>    */}
                                Расписание занятий 
                                </Typography>

                                <Typography gutterBottom variant="h5" align="center">
                                 {/* <SportsIcon/>   */}
                                  Младшая группа
                                </Typography>
                                <Typography gutterBottom align="center">
                                    Пн: 17:00 -  18:30 <br />
                                    Вт: 17:00 -  18:30<br />
                                    Пт: 17:00 -  18:30
                                </Typography>

                                <Typography gutterBottom variant="h5" align="center">
                                {/* <SportsIcon/> */}
                                  Старшая группа
                                </Typography>
                                <Typography gutterBottom align="center">
                                    Пн: 18:30 -  20:30 <br />
                                    
                                    Ср: 18:30 -  20:30<br />
                                    
                                    Пт: 18:30 -  20:30
                                </Typography>
                            </Grid>
                        </Grid>

                    </Grid>
                </Paper>
                //)}
            ))}

        </div>
    );
};

export const ContactUs = (props) => (
    <List title="All comments" {...props} pagination={false} actions={<ListActions />}>
        <ContactUsGrid id='SS1' />
    </List>
);